module.exports = __webpack_public_path__ + "img/6.39b2f21b.png";